import { getFullComposeViewState } from 'owa-calendar-compose-store-manager';
import { FullComposeFormViewType } from 'owa-calendar-helpers-types/lib/ComposeTypes';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';

export function isInPopOutWindow(formId: string): boolean {
    return isInDeeplinkPopOutWindow(formId) || isInProjectionPopOutWindow(formId);
}

export function isInDeeplinkPopOutWindow(formId: string): boolean {
    return getFullComposeViewState(formId)?.viewType == FullComposeFormViewType.DeeplinkPopOut;
}

export function isInProjectionPopOutWindow(formId: string): boolean {
    return getFullComposeViewState(formId)?.viewType == FullComposeFormViewType.ProjectionPopOut;
}

export function isInNativeProjectionPopOutWindow(formId: string): boolean {
    return isInProjectionPopOutWindow(formId) && isHostAppFeatureEnabled('openNewEventInNewWindow');
}
